/* eslint-disable */
export const bookings = '/bookings';
export const booking = (bookingId: number) =>
  `${bookings}/${bookingId}`;

